import React from "react";
import {
  Drawer,
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  IconButton,
  Slider,
  MenuItem,
  Select,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/* ---------- COLORS ---------- */
const BROWN = "#6B3F2B";
const GREEN = "#00B26D";
const BORDER = "#C9B7AE";

const SortFilterDrawer = ({
  open,
  onClose,
  categories,
  tab,
  setTab,
  selectedCategoryIds,
  priceRange,
  setPriceRange,
  trayLevel,
  setTrayLevel,
  sortValue,
  setSortValue,
  handleReset,
  handleCategoryToggle,
  ApplyFillter,
}) => {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          height: tab === "sort" ? "70vh" : "90vh",
        },
      }}
    >
      {/* ---------- HEADER ---------- */}
      <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>

        <Typography fontWeight={600}>Sort & Filters</Typography>

        <Typography
          fontWeight={600}
          sx={{ cursor: "pointer", color: BROWN }}
          onClick={handleReset}
        >
          Reset
        </Typography>
      </Box>

      {/* ---------- SEGMENTED TABS ---------- */}
      <Box px={2} mb={2}>
        <ToggleButtonGroup
          value={tab}
          exclusive
          fullWidth
          onChange={(e, val) => val && setTab(val)}
          sx={{
            border: `1px solid ${BROWN}`,
            borderRadius: "28px",
            overflow: "hidden",
               "&:hover": { bgcolor: "#BROWN" },
          }}
        >
          {["sort", "filters"].map((value) => (
            <ToggleButton
              key={value}
              value={value}
              sx={{
                border: "none",
                textTransform: "none",
                fontWeight: 600,
                color: tab === value ? "#fff" : BROWN,
                backgroundColor: tab === value ? BROWN : "transparent",
                "&.Mui-selected": {
                  backgroundColor: BROWN,
                  color: "#fff",
                    
                },
                     "&:hover": { bgcolor: "#BROWN" },
              }}
            >
              {value === "sort" ? "Sort by" : "Filters"}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>

      {/* ---------- CONTENT ---------- */}
      <Box px={2} sx={{ overflowY: "auto" }}>
        {/* FILTERS */}
        {tab === "filters" && (
          <>
            {/* Categories */}
            <Box display="flex" flexWrap="wrap" gap={1.2} mb={3}>
              {categories.map((cat) => {
                const selected = selectedCategoryIds.includes(cat.id);
                return (
                  <Chip
                    key={cat.id}
                    label={cat.name}
                    clickable
                    onClick={() => handleCategoryToggle(cat.id)}
                   
                    sx={{
                      px: 1,
                      borderRadius: "20px",
                      border: `1px solid ${BORDER}`,
                      fontWeight: 500,
                      backgroundColor: selected ? BROWN : "#fff",
                      color: selected ? "#fff" : "#BROWN",
                      
                      
                      
                    }}
                  />
                );
              })}
            </Box>

            {/* Price Range */}
            <Typography fontWeight={600} mb={1}>
              Price Range
            </Typography>

            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography>₹{priceRange[0]}</Typography>
              <Typography>₹{priceRange[1]}</Typography>
            </Box>

            <Slider
              value={priceRange}
              onChange={(e, val) => setPriceRange(val)}
              min={0}
              max={250}
              sx={{
                color: BROWN,
                "& .MuiSlider-thumb": {
                  backgroundColor: BROWN,
                },
                "& .MuiSlider-track": {
                  backgroundColor: BROWN,
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#E0E0E0",
                },
              }}
            />

            {/* Tray Level */}
            <Typography mt={3} mb={1} fontWeight={600}>
              Tray Level
            </Typography>

            <Select
              fullWidth
              value={trayLevel}
              onChange={(e) => setTrayLevel(e.target.value)}
              sx={{ borderRadius: 2 }}
            >
              <MenuItem value="all">All</MenuItem>
              {[1, 2, 3, 4, 5, 6].map((v) => (
                <MenuItem key={v} value={v}>
                  {v}
                </MenuItem>
              ))}
            </Select>
          </>
        )}

        {/* SORT */}
        {tab === "sort" && (

<RadioGroup
  value={sortValue}
  onChange={(e) => setSortValue(e.target.value)}
>
  {/* Stacking options */}
  <FormControlLabel
    value="stack-top"
    control={
      <Radio sx={{ color: BROWN, "&.Mui-checked": { color: GREEN } }} />
    }
    label="Stacking: Top to Bottom"
  />

  <FormControlLabel
    value="stack-bottom"
    control={
      <Radio sx={{ color: BROWN, "&.Mui-checked": { color: GREEN } }} />
    }
    label="Stacking: Bottom to Top"
  />

  {/* 🔹 Divider after stacking */}
  <Divider sx={{ my: 1 }} />

  {/* Price options */}
  <FormControlLabel
    value="price-low"
    control={
      <Radio sx={{ color: BROWN, "&.Mui-checked": { color: GREEN } }} />
    }
    label="Price: Low to High"
  />

  <FormControlLabel
    value="price-high"
    control={
      <Radio sx={{ color: BROWN, "&.Mui-checked": { color: GREEN } }} />
    }
    label="Price: High to Low"
  />

  {/* 🔹 Divider after price */}
  <Divider sx={{ my: 1 }} />
</RadioGroup>

        )}
      </Box>

      {/* ---------- APPLY ---------- */}
      <Box p={2}>
        <Button
          fullWidth
          variant="contained"
          sx={{
            height: 52,
            borderRadius: 3,
            backgroundColor: GREEN,
            fontWeight: 600,
            fontSize: 16,
          }}
          onClick={ApplyFillter}
        >
          Apply
        </Button>
      </Box>
    </Drawer>
  );
};

export default SortFilterDrawer;
